import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

const getViewedStoreId = () => {
  try {
    if (localStorage.getItem('adminViewMode') !== 'site') {
      return null;
    }

    const siteViewStore = JSON.parse(localStorage.getItem('siteViewStore') || 'null');
    return siteViewStore?.id ? String(siteViewStore.id) : null;
  } catch (error) {
    return null;
  }
};

api.interceptors.request.use((config) => {
  const viewedStoreId = getViewedStoreId();
  if (viewedStoreId) {
    config.headers['X-View-Store-Id'] = viewedStoreId;
  } else if (config.headers && config.headers['X-View-Store-Id']) {
    delete config.headers['X-View-Store-Id'];
  }

  return config;
});

// Add token to requests
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('store');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
